import { render, staticRenderFns } from "./CreateAdvice.vue?vue&type=template&id=0adf6c0a&scoped=true&"
import script from "./CreateAdvice.vue?vue&type=script&lang=js&"
export * from "./CreateAdvice.vue?vue&type=script&lang=js&"
import style0 from "./CreateAdvice.vue?vue&type=style&index=0&id=0adf6c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf6c0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0adf6c0a')) {
      api.createRecord('0adf6c0a', component.options)
    } else {
      api.reload('0adf6c0a', component.options)
    }
    module.hot.accept("./CreateAdvice.vue?vue&type=template&id=0adf6c0a&scoped=true&", function () {
      api.rerender('0adf6c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/patient/components/Advice/components/CreateAdvice.vue"
export default component.exports